module.exports = __webpack_public_path__ + "img/3.d96e7968.png";